import one from "../assets/svg/projects/one.svg";
import two from "../assets/svg/projects/two.svg";
import three from "../assets/svg/projects/three.svg";
import four from "../assets/svg/projects/four.svg";
// import five from "../assets/svg/projects/five.svg";
// import six from "../assets/svg/projects/six.svg";
import seven from "../assets/svg/projects/seven.svg";
// import eight from "../assets/svg/projects/eight.svg";

export const projectsData = [
  {
    id: 1,
    projectName: "Real-time Chat Application",
    projectDesc:
      "A real-time chat app supporting instant messaging using WebSockets and Firebase, designed for seamless user communication with authentication and group chat features.",
    tags: ["React", "JavaScript", "CSS", "Firebase", "Node.js"],
    code: "",
    demo: "",
    image: two,
  },
  {
    id: 2,
    projectName: "Snap Tap",
    projectDesc:
      "A freelancing project to store and share personal/business information through digital cards. One tap on the card shares all your details instantly.",
    tags: ["React", "JavaScript", "CSS", "Node.js"],
    code: "",
    demo: "",
    image: three,
  },
  {
    id: 3,
    projectName: "E-Commerce Website",
    projectDesc:
      "A complete e-commerce website with product browsing, cart, and checkout, offering smooth UX with responsive design",
    tags: ["HTML", "CSS", "JavaScript", "jQuery"],
    code: "https://github.com/ithink24/E-Commerce-Website",
    demo: "https://github.com/ithink24/E-Commerce-Website",
    image: four,
  },
  {
    id: 4,
    projectName: "Rails Template",
    projectDesc:
      "A reusable Rails template with built-in authentication, linting, and deployment setup to speed up the development of new Rails apps.",
    tags: ["Ruby on Rails", "Ruby"],
    code: "https://github.com/ithink24/rails-template",
    demo: "https://github.com/ithink24/rails-template",
    image: one,
  },

  {
    id: 5,
    projectName: "Covid-19 Tracker",
    projectDesc:
      "An interactive dashboard to track COVID-19 cases globally, providing real-time data and visualizations with Django and public APIs.",
    tags: ["Django", "CSS", "Material UI"],
    code: "https://github.com/ithink24/Covid-19-tracker",
    demo: "https://github.com/ithink24/Covid-19-tracker",
    image: seven,
  },
];
